import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-filter",
  "use": "icon-filter-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-filter\">\r\n<path d=\"M118,12.8c-1.9-4.5-6.3-7.5-11.2-7.4H20.5c-6.6,0-11.9,5.4-11.9,11.9c0,3.1,1.3,6.2,3.5,8.4l39.5,37.9v37.7\r\n\tc0,1.4,0.5,2.7,1.5,3.6l18,18.4c1,1,2.3,1.6,3.7,1.6c0.7,0,1.3-0.1,2-0.4c2-0.8,3.3-2.7,3.3-4.8V63.4l35.7-37.6\r\n\tC119,22.3,119.9,17.2,118,12.8L118,12.8z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/filter.svg
// module id = ObMl
// module chunks = 77